import { createPlaidLinkToken } from 'shared/mutations'
import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'

const CreatePlaidToken = ({ children, ...rest }) => {
  return (
    <Mutation mutation={createPlaidLinkToken}>
      {(createPlaidToken, { loading }) =>
        children({ createPlaidToken, loading, ...rest })
      }
    </Mutation>
  )
}

CreatePlaidToken.propTypes = {
  children: PropTypes.func.isRequired,
}

export default CreatePlaidToken
